import ViewController from "core/views/view.controller";

export default class LoginCtrl extends ViewController {
    static $inject = ['$scope', '$state', '$ionicPopup', '$translate', '$loadingIndicator', 'settings', 'authService', 'Branches'];

    constructor() {
        super(...arguments);
    }

    $onViewBeforeEnter() {
        this.host = this.settings.host;
        if(!this.host){
            this.host= window.location.hostname.split('.')[0];
        }

        this.$loadingIndicator.disable();
    }

    $onViewAfterLeave() {
        this.host = null;
        this.username = null;
        this.password = null;
    }

    loginDemo() {
        this.host = "demo";
        this.username = "demo";
        this.password = "demo";
    }

    login() {
        this.authService.login(this.host, this.username, this.password)
            .then((user)=> {
                this.settings.host = this.host;
                this.settings.user = user;

                this.settings.save();

                return this.Branches.all();
            })
            .then((branches)=> {
                this.$loadingIndicator.enable();

                if (branches.length > 1) {
                    this.$state.go('branch-selection');

                } else {
                    this.settings.branch = branches[0];
                    this.settings.save();
                    this.$state.go('tab.dashboard');
                }
            })
            .catch(() => {
                this.showLoginError();
            });
    }

    showLoginError() {
        this.$translate([
            'LOGIN_TITLE',
            'LOGIN_WRONG_CREDENTIALS'

        ]).then((translations) => {
            this.$ionicPopup.alert({
                title: translations.LOGIN_TITLE,
                template: translations.LOGIN_WRONG_CREDENTIALS,
                okType: 'button-stable button-clear'
            });
        });
    }
}



// WEBPACK FOOTER //
// ./src/modules/main/views/login/login.controller.js